<template>
  <div class="compute-page">
    <!-- 背景装饰 -->
    <div class="page-bg">
      <div class="bg-orb orb-1"></div>
      <div class="bg-orb orb-2"></div>
      <div class="bg-orb orb-3"></div>
    </div>

    <div class="page-container">
      <!-- ===== 空状态：暂无算力服务器 ===== -->
      <div v-if="!productList.length && loadingOver" class="empty-state">
        <div class="empty-icon">
          <svg
            viewBox="0 0 24 24"
            width="64"
            height="64"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
            <line x1="8" y1="21" x2="16" y2="21"></line>
            <line x1="12" y1="17" x2="12" y2="21"></line>
            <path d="M6 8h.01M10 8h.01M14 8h.01M18 8h.01"></path>
          </svg>
        </div>
        <h2 class="empty-title">{{ $t("info.emptyTitle") }}</h2>
        <p class="empty-desc">{{ $t("info.emptyDesc") }}</p>
      </div>

      <!-- ===== 顶部国家切换Tab ===== -->
      <div v-if="productList.length" class="tab-wrap">
        <div
          v-for="item in productList"
          :key="item.id"
          class="tab-item"
          :class="{ active: currentCountry === item.country_id }"
          @click="switchCountry(item.country_id)"
        >
          <div class="flag">
            <img class="gqd" :src="item.country_img" :alt="item.country_name" />
          </div>
          <div class="country-name">{{ $t("country." + item.country_id) }}</div>
          <span
            v-if="currentCountry === item.country_id"
            class="tab-active-dot"
          ></span>
        </div>
      </div>

      <!-- ===== 主内容卡片 ===== -->
      <div class="content-card" v-if="currentProduct">
        <!-- 左侧产品介绍 -->
        <div class="card-left">
          <!-- <div class="product-badge">
            <span class="badge-dot"></span>
            {{ currentProduct.country_name }}算力节点
          </div> -->
          <h1 class="product-name">{{ currentProduct.title }}</h1>
          <div class="divider"></div>
          <!-- 产品数据指标 -->
          <!-- <div class="product-metrics">
            <div class="metric-item">
              <span class="metric-value"
                >${{ currentProduct.top_data?.latest_price ?? "-" }}</span
              >
              <span class="metric-label">{{ $t("info.latestPrice") }}</span>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <span class="metric-value"
                >${{ currentProduct.top_data?.last_price ?? "-" }}</span
              >
              <span class="metric-label">昨日价格</span>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <span
                class="metric-value"
                :class="getIncreaseClass(currentProduct.top_data?.rate)"
              >
                {{ currentProduct.top_data?.rate ?? 0 }}%
              </span>
              <span class="metric-label">增幅</span>
            </div>
          </div> -->

          <!-- 产品服务详情 -->
          <h3 class="product-title">
            {{ $t("token." + currentProduct.content + ".content.title") }}
          </h3>

          <!-- 产品服务介绍文案 -->
          <div class="service-intro">
            <div
              class="service-intro-content"
              :class="{ expanded: introExpanded }"
              v-html="
                $t('token.' + currentProduct.content + '.content.content')
              "
            ></div>
            <button
              v-if="showIntroExpandBtn"
              class="intro-expand-btn"
              @click="toggleIntroExpand"
            >
              <span>{{
                introExpanded ? $t("info.collapse") : $t("info.expand")
              }}</span>
              <svg
                class="intro-expand-icon"
                :class="{ rotated: introExpanded }"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>

          <!-- 产品服务详情菜单：借鉴顶部国家切换Tab样式 -->
          <div class="detail-menu">
            <button
              v-for="tab in detailTabs"
              :key="tab"
              class="detail-menu-btn"
              :class="{ active: detailTab === tab }"
              @click="switchDetailTab(tab)"
            >
              {{ $t("token." + currentProduct.content + "." + tab + ".title") }}
              <span
                v-if="detailTab === tab"
                class="detail-menu-active-dot"
              ></span>
            </button>
          </div>

          <!-- 产品描述 - 带展开功能 -->
          <div class="product-desc-wrapper">
            <div class="product-desc" :class="{ expanded: isExpanded }">
              <!-- 文案 -->
              <div v-if="detailTab === 't1'" class="detail-content">
                <div
                  v-html="$t('token.' + currentProduct.content + '.t1.content')"
                ></div>
              </div>
              <!-- 文案 -->
              <div v-else-if="detailTab === 't2'" class="detail-content">
                <div
                  v-html="$t('token.' + currentProduct.content + '.t2.content')"
                ></div>
              </div>
              <!-- 文案 -->
              <div v-else-if="detailTab === 't3'" class="detail-content">
                <div
                  v-html="$t('token.' + currentProduct.content + '.t3.content')"
                ></div>
              </div>
              <!-- 文案 -->
              <div v-else-if="detailTab === 't4'" class="detail-content">
                <div
                  v-html="$t('token.' + currentProduct.content + '.t4.content')"
                ></div>
              </div>
            </div>
            <!-- 展开/收起按钮 -->
            <div class="expand-bg">
              <button
                v-if="showExpandBtn"
                class="expand-btn"
                @click="toggleExpand"
              >
                <span class="expand-text">{{
                  isExpanded
                    ? $t("info.collapseDetail")
                    : $t("info.expandDetail")
                }}</span>
                <svg
                  class="expand-icon"
                  :class="{ rotated: isExpanded }"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- 右侧算力趋势图表 -->
        <div class="card-right">
          <div class="chart-header">
            <span class="chart-title">{{ $t("info.priceTrend") }}</span>
            <div class="chart-range-tabs">
              <button
                v-for="range in chartRanges"
                :key="range.value"
                class="chart-range-btn"
                :class="{ active: chartRange === range.value }"
                @click="switchChartRange(range.value)"
              >
                {{ range.label }}
              </button>
            </div>
            <span class="chart-unit">{{ $t("info.unit") }}：$</span>
          </div>
          <div style="width: 100%; height: 360px; margin-bottom: 50px">
            <div
              ref="chartRef"
              class="chart-box"
              style="width: 100%; height: 100%"
            ></div>
          </div>
          <!-- 产品数据指标 -->
          <div class="product-metrics">
            <div class="metric-item">
              <span class="metric-value stat-high"
                >${{ currentProduct.top_data?.latest_price ?? "-" }}</span
              >
              <span class="metric-label">{{ $t("info.latestPrice") }}</span>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <span class="metric-value stat-avg"
                >${{ currentProduct.top_data?.last_price ?? "-" }}</span
              >
              <span class="metric-label">{{ $t("info.lastPrice") }}</span>
            </div>
            <div class="metric-divider"></div>
            <div class="metric-item">
              <span
                class="metric-value"
                :class="getIncreaseClass(currentProduct.top_data?.rate)"
              >
                {{ currentProduct.top_data?.rate ?? 0 }}%
              </span>
              <span class="metric-label">{{ $t("info.increase") }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== 立即购买按钮 ===== -->
      <div v-if="productList.length" class="btn-wrap">
        <button class="join-btn" @click="openPurchaseModal">
          <span class="btn-text">{{ $t("info.buyNow") }}</span>
          <span class="btn-arrow">→</span>
          <span class="btn-glow"></span>
        </button>
      </div>
    </div>

    <!-- ===== 购买弹窗 (Element UI) ===== -->
    <el-dialog
      :visible.sync="purchaseModalVisible"
      :title="$t('info.buyCompute')"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closePurchaseModal"
      class="purchase-dialog"
    >
      <div class="purchase-modal-content">
        <!-- 产品信息 -->
        <div class="product-info-bar">
          <img class="product-flag" :src="currentProduct?.country_img" alt="" />
          <span class="product-name-text">{{ currentProduct?.title }}</span>
          <span class="product-price-tag">${{ currentPrice }}</span>
        </div>

        <!-- 周期选择 -->
        <div class="modal-section">
          <div class="section-label">
            <span class="label-icon">📅</span>
            <span>{{ $t("info.selectPeriod") }}</span>
          </div>
          <div class="period-group-modal">
            <button
              v-for="period in periodOptions"
              :key="period.days"
              class="period-btn-modal"
              :class="{ active: selectedPeriod === period.days }"
              @click="selectPeriod(period.days)"
            >
              <div class="period-days-wrap">
                <span class="period-days-modal">{{ period.days }}</span>
                <span class="period-unit-modal">{{ $t("info.day") }}</span>
              </div>
              <span
                v-if="getPeriodDisplayRate(period) > 0"
                class="period-rate-badge"
              >
                <svg
                  class="rate-icon-modal"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  fill="none"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                  <polyline points="17 6 23 6 23 12"></polyline>
                </svg>
                <span class="rate-value-modal"
                  >+{{ getPeriodDisplayRate(period) }}%</span
                >
              </span>
            </button>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between">
          <!-- 截止时间 -->
          <div class="modal-section deadline-section">
            <div class="section-label">
              <span class="label-icon">⏱️</span>
              <span>{{ $t("info.periodTime") }}</span>
            </div>
            <div class="deadline-modal">
              <span class="deadline-time-modal">{{ deadlineTime }}</span>
            </div>
          </div>

          <!-- 购买数量 -->
          <div class="modal-section">
            <div class="section-label">
              <span class="label-icon">🔢</span>
              <span>{{ $t("info.purchaseQuantity") }}</span>
            </div>
            <div class="quantity-control-modal">
              <button class="qty-btn-modal" @click="decreaseQuantity">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
              </button>
              <input
                type="number"
                v-model.number="purchaseQuantity"
                class="qty-input-modal"
                min="1"
                :max="maxQuantity"
                @input="validateQuantity"
              />
              <button class="qty-btn-modal" @click="increaseQuantity">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- 收益预览 -->
        <div class="section-label">
          <span class="label-icon">💰</span>
          <span>{{ $t("info.expectedProfit") }}</span>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('info.profitTip')"
            placement="top"
          >
            <i class="el-icon-question xxb"></i>
          </el-tooltip>
        </div>
        <div class="modal-section profit-preview">
          <div class="profit-grid">
            <div class="profit-item-modal">
              <span class="profit-label-modal">
                {{ $t("info.baseProfit") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('info.settle24h')"
                  placement="top"
                >
                  <i class="el-icon-question xxb"></i>
                </el-tooltip>
              </span>
              <span class="profit-value-modal">${{ expectedProfit }}</span>
            </div>
            <div class="profit-divider-modal"></div>
            <div class="profit-item-modal period-profit-item">
              <span class="profit-label-modal"
                >{{ $t("info.periodProfit") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('info.settleDue')"
                  placement="top"
                >
                  <i class="el-icon-question xxb"></i>
                </el-tooltip>
              </span>
              <span class="profit-value-modal period-profit-modal"
                >${{ periodProfit }}</span
              >
              <!-- <span v-if="getPeriodRate() > 0" class="period-rate-highlight"
                >+{{ getPeriodRate() * 100 }}%</span
              > -->
            </div>
            <div class="profit-divider-modal"></div>
            <div class="profit-item-modal">
              <span class="profit-label-modal">{{
                $t("info.totalProfit")
              }}</span>
              <span class="profit-value-modal total-profit-modal"
                >${{ totalProfit }}</span
              >
            </div>
          </div>
        </div>

        <!-- ===== 金额汇总区域（替换原来的三个独立 total-bar） ===== -->
        <!-- 收益预览 -->
        <div class="section-label">
          <span class="label-icon">💰</span>
          <span>{{ $t("info.fundDetail") }}</span>
        </div>
        <div class="summary-section">
          <div class="summary-grid">
            <!-- 金额 -->
            <div class="summary-item">
              <span class="summary-label">
                <span class="label-icon">💰</span>
                {{ $t("info.purchaseAmount") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('info.buyFormula')"
                  placement="top"
                >
                  <i class="el-icon-question xxb"></i>
                </el-tooltip>
              </span>
              <span class="summary-value">${{ purchaseTotal }}</span>
            </div>

            <!-- 手续费 -->
            <div class="summary-item">
              <span class="summary-label">
                <span class="label-icon">⚡</span>
                {{ $t("info.fee") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="
                    $t('info.feeFormula', {
                      fee: (currentProduct?.buy_fee * 100).toFixed(2),
                    })
                  "
                  placement="top"
                >
                  <i class="el-icon-question xxb"></i>
                </el-tooltip>
              </span>
              <span class="summary-value fee-value">${{ purchaseFee }}</span>
            </div>

            <!-- 总计（高亮） -->
            <div class="summary-item total-item">
              <span class="summary-label">
                <span class="label-icon">🏷️</span>
                {{ $t("info.total") }}
              </span>
              <span class="summary-value total-value"
                >${{
                  (parseFloat(purchaseTotal) + parseFloat(purchaseFee)).toFixed(
                    2,
                  )
                }}</span
              >
            </div>
          </div>
        </div>

        <!-- 可用余额（独立一行） -->
        <div class="summary-item balance-item">
          <span class="summary-label">
            <span class="label-icon">💰</span>
            {{ $t("memberBox.availableBalance") }}
          </span>
          <span class="summary-value balance-value">${{ walletBalance }}</span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closePurchaseModal">{{
          $t("info.cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="handleBuy"
          :loading="buyLoading"
          :disabled="buyLoading"
        >
          {{ $t("info.confirmBuy") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- ===== 交易密码弹窗（使用组件） ===== -->
    <TradePasswordModal
      :visible.sync="passwordModalVisible"
      :product-info="passwordProductInfo"
      :loading="buyLoading"
      :error="passwordError"
      :title="$t('info.tradeConfirm')"
      :label-text="$t('info.enterPassword')"
      :placeholder="$t('info.enterPassword')"
      :confirm-text="$t('info.confirmPay')"
      :cancel-text="$t('info.cancel')"
      @confirm="handlePasswordConfirm"
      @cancel="handlePasswordCancel"
      @close="handlePasswordClose"
    />
  </div>
</template>

<script>
import * as echarts from "echarts";
import TradePasswordModal from "@/components/toast/TradePasswordModal.vue";

export default {
  name: "InfoView",
  components: {
    TradePasswordModal,
  },
  data() {
    return {
      code: "",
      productList: [],
      currentCountry: null,
      chartInstance: null,
      resizeTimer: null,

      // ===== 趋势图时间范围 =====
      chartRange: 30,
      chartRanges: [
        { label: this.$t("info.chart7d"), value: 7 },
        { label: this.$t("info.chart15d"), value: 15 },
        { label: this.$t("info.chart30d"), value: 30 },
      ],

      // ===== 购买相关 =====
      purchaseQuantity: 1,
      selectedPeriod: 3,
      maxQuantity: 9999,

      // ===== 弹窗控制 =====
      purchaseModalVisible: false,
      passwordModalVisible: false,
      buyLoading: false,
      passwordError: "",

      // ===== 展开/收起 =====
      isExpanded: false,
      showExpandBtn: false,

      // ===== 产品服务介绍文案展开/收起 =====
      introExpanded: false,
      showIntroExpandBtn: false,

      // ===== 产品服务详情菜单 =====
      detailTab: "t1",
      detailTabs: ["t1", "t2", "t3", "t4"],

      //加载数据中
      loadingOver: false,

      // ===== 钱包可用余额 =====
      wallet: {},
    };
  },
  computed: {
    currentProduct() {
      if (!this.productList.length) return null;
      return (
        this.productList.find(
          (item) => item.country_id === this.currentCountry,
        ) || this.productList[0]
      );
    },
    periodOptions() {
      return this.currentProduct?.period || [];
    },
    currentPrice() {
      return parseFloat(this.currentProduct?.top_data?.latest_price) || 0;
    },

    // ===== 密码弹窗产品信息 =====
    passwordProductInfo() {
      if (!this.currentProduct) return null;
      return {
        img: this.currentProduct.country_img,
        name: this.currentProduct.title,
        price: this.currentPrice.toFixed(2),
      };
    },

    purchaseTotal() {
      return (this.currentPrice * this.purchaseQuantity).toFixed(2);
    },

    purchaseFee() {
      return (this.purchaseTotal * this.currentProduct?.buy_fee || 0).toFixed(
        2,
      );
    },

    expectedProfit() {
      const avgIncome = parseFloat(this.currentProduct?.avg_income) || 0;
      if (avgIncome <= 0 || this.purchaseQuantity <= 0) {
        return "0.00";
      }

      const days = this.selectedPeriod;
      // 预计收益 = 天数 × 平均收益 × 购买数量
      const result = days * avgIncome * this.purchaseQuantity;
      return result.toFixed(2);
    },

    periodProfit() {
      const expected = parseFloat(this.expectedProfit) || 0;
      const rate = this.getPeriodRate();
      const result = expected * rate;
      return result.toFixed(2);
    },

    totalProfit() {
      const expected = parseFloat(this.expectedProfit) || 0;
      const period = parseFloat(this.periodProfit) || 0;
      return (expected + period).toFixed(2);
    },

    deadlineTime() {
      const days = this.selectedPeriod;
      const deadline = this.$dayjs().add(days, "day");

      return deadline.toDate().toLocaleString("en-US", {
        timeZone: "America/New_York",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },

    walletBalance() {
      const val = parseFloat(this.wallet?.balance);
      return isNaN(val) ? "0.00" : val.toFixed(2);
    },
  },
  watch: {
    currentCountry: {
      handler() {
        this.$nextTick(() => {
          this.updateChart();
          this.isExpanded = false;
          this.checkDescHeight();
        });
      },
      immediate: true,
    },
    productList: {
      handler() {
        if (this.productList.length) {
          this.$nextTick(() => {
            this.updateChart();
            this.checkDescHeight();
          });
        }
      },
      deep: true,
    },
  },
  created() {
    this.code = this.$route.query.code || "";
    this.getWallet();
    this.getTokenList();
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.checkIntroHeight();
    });
  },

  beforeDestroy() {
    this.destroyChart();
  },
  methods: {
    getWallet() {
      this.$api.userWallet
        .getWallet()
        .then((res) => {
          this.wallet = res.data || {};
        })
        .catch(() => {
          this.wallet = {};
        });
    },
    getPeriodRate() {
      const period = this.periodOptions.find(
        (p) => p.days === this.selectedPeriod,
      );
      return period ? period.rate : 0;
    },

    // ===== 计算周期按钮显示的收益率 =====
    // 默认显示 avg_rate，如果周期 rate > 0，则显示 avg_rate + avg_rate * period.rate
    getPeriodDisplayRate(period) {
      const avgRate = parseFloat(this.currentProduct?.avg_rate) || 0;
      if (avgRate <= 0) return 0;

      if (period.rate > 0) {
        return ((avgRate + avgRate * period.rate) * 100).toFixed(2);
      }
      return (avgRate * 100).toFixed(2);
    },

    async getTokenList() {
      try {
        const res = await this.$api.token.getTokenList();
        this.loadingOver = true;
        if (res.code === 1) {
          this.$message.warning(res.msg);
          return;
        }
        this.productList = res.data || [];

        if (this.code) {
          const matched = this.productList.find(
            (item) => item.code === this.code,
          );
          this.currentCountry =
            matched?.country_id || this.productList[0]?.country_id || null;
        } else {
          this.currentCountry = this.productList[0]?.country_id || null;
        }

        //初始化周期
        if (this.currentProduct?.period?.length) {
          this.selectedPeriod = this.currentProduct.period[0].days;
        }

        this.$nextTick(() => {
          this.checkDescHeight();
        });
      } catch (error) {
        console.error("获取产品列表失败:", error);
        this.$message.error(this.$t("info.fetchFail"));
      }
    },

    switchCountry(id) {
      if (this.currentCountry === id) return;
      this.currentCountry = id;
      this.resetPurchase();
    },

    // ===== 切换趋势图时间范围 =====
    switchChartRange(range) {
      if (this.chartRange === range) return;
      this.chartRange = range;
      this.updateChart();
    },

    // ===== 弹窗控制 =====
    openPurchaseModal() {
      if (!this.currentProduct) {
        this.$message.warning(this.$t("info.selectProduct"));
        return;
      }
      this.purchaseModalVisible = true;
    },

    closePurchaseModal() {
      this.purchaseModalVisible = false;
    },

    // ===== 购买数量控制 =====
    increaseQuantity() {
      if (this.purchaseQuantity < this.maxQuantity) {
        this.purchaseQuantity++;
      }
    },
    decreaseQuantity() {
      if (this.purchaseQuantity > 1) {
        this.purchaseQuantity--;
      }
    },
    validateQuantity() {
      if (this.purchaseQuantity < 1) {
        this.purchaseQuantity = 1;
      }
      if (this.purchaseQuantity > this.maxQuantity) {
        this.purchaseQuantity = this.maxQuantity;
      }
    },

    selectPeriod(days) {
      this.selectedPeriod = days;
    },

    resetPurchase() {
      this.purchaseQuantity = 1;

      //找到默认周期
      if (this.currentProduct?.period?.length) {
        this.selectedPeriod = this.currentProduct.period[0].days;
      }
    },

    // ===== 确认购买（打开密码弹窗） =====
    handleBuy() {
      if (this.purchaseQuantity < 1) {
        this.$message.warning(this.$t("info.quantityMin"));
        return;
      }
      if (this.currentPrice <= 0) {
        this.$message.warning(this.$t("info.priceError"));
        return;
      }
      // 清空之前的错误和密码
      this.passwordError = "";
      // 打开密码弹窗
      this.passwordModalVisible = true;
    },

    // ===== 密码确认回调 =====
    async handlePasswordConfirm(password) {
      this.buyLoading = true;
      this.passwordError = "";

      const params = {
        code: this.currentProduct.code,
        quantity: this.purchaseQuantity,
        period: this.selectedPeriod,
        trade_password: password,
      };

      try {
        const res = await this.$api.token.buyToken(params);
        if (res.code === 0) {
          this.$message.success(res.msg || this.$t("info.buySuccess"));
          this.passwordModalVisible = false;
          this.purchaseModalVisible = false;
          await this.getTokenList();
        } else {
          // 密码错误或其他错误
          this.passwordError = res.msg || this.$t("info.tradeFail");
          // 如果是密码错误，让用户重新输入
          if (res.code === 1002 || res.msg?.includes("密码")) {
            this.passwordError = res.msg || this.$t("info.passwordError");
          }
        }
      } catch (err) {
        console.error("购买失败:", err);
        this.passwordError = this.$t("info.buyFail");
      } finally {
        this.buyLoading = false;
      }
    },

    // ===== 密码取消回调 =====
    handlePasswordCancel() {
      this.passwordModalVisible = false;
      this.passwordError = "";
    },

    // ===== 密码弹窗关闭回调 =====
    handlePasswordClose() {
      this.passwordModalVisible = false;
      this.passwordError = "";
    },

    // ===== 产品服务介绍文案展开/收起 =====
    toggleIntroExpand() {
      this.introExpanded = !this.introExpanded;
    },

    // ===== 切换产品服务详情菜单 =====
    switchDetailTab(tab) {
      if (this.detailTab === tab) return;
      this.detailTab = tab;
      this.isExpanded = false;
      this.$nextTick(() => {
        this.checkDescHeight();
      });
    },

    // ===== 展开/收起 =====
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    checkDescHeight() {
      const descEl = this.$el?.querySelector(".product-desc");
      if (descEl) {
        descEl.style.maxHeight = "none";
        const height = descEl.scrollHeight;
        descEl.style.maxHeight = "";
        this.showExpandBtn = height > 300;
      }
    },

    // ===== 检测产品服务介绍文案是否需要展开按钮 =====
    checkIntroHeight() {
      const introEl = this.$el?.querySelector(".service-intro-content");
      if (introEl) {
        introEl.style.maxHeight = "none";
        const height = introEl.scrollHeight;
        introEl.style.maxHeight = "";
        this.showIntroExpandBtn = height > 120;
      }
    },

    getIncreaseClass(value) {
      if (value === null || value === undefined) return "";
      const num = parseFloat(value);
      if (isNaN(num)) return "";
      return num >= 0 ? "increase-up" : "increase-down";
    },

    initChart() {
      if (!this.$refs.chartRef) {
        setTimeout(() => {
          this.initChart();
        }, 300);
        return;
      }

      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }

      this.chartInstance = echarts.init(this.$refs.chartRef);
      this.updateChart();
      this.handleResize();
    },

    updateChart() {
      if (!this.chartInstance || !this.currentProduct) return;

      const trendData = this.currentProduct.top_trend || [];
      // 根据 chartRange 过滤最近 N 天数据
      const filteredData = trendData.slice(-this.chartRange);
      const dates = filteredData.map((item) => item.date || "");
      const prices = filteredData.map((item) => item.price ?? 0);

      const hasData = prices.some((v) => v > 0);
      const maxPrice = Math.max(...prices, 0);
      const minPrice = Math.min(...prices, 0);

      const option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const p = params[0];
            return `<strong>${p.name}</strong><br/>${this.$t(
              "info.price",
            )}：<strong>$${p.value}</strong>`;
          },
          backgroundColor: "rgba(10, 14, 26, 0.85)",
          borderColor: "rgba(0, 180, 255, 0.2)",
          borderWidth: 1,
          textStyle: { color: "#fff", fontSize: 12 },
        },
        grid: {
          left: 50,
          right: 20,
          bottom: 32,
          top: 16,
        },
        xAxis: {
          type: "category",
          data: dates.length ? dates : [this.$t("info.noData")],
          axisLine: { lineStyle: { color: "rgba(255,255,255,0.08)" } },
          axisLabel: {
            color: "rgba(255,255,255,0.35)",
            fontSize: 10,
          },
          axisTick: { show: false },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.05)",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "rgba(255,255,255,0.35)",
            fontSize: 10,
            formatter: (value) => "$" + value,
          },
          name: this.$t("info.price"),
          nameTextStyle: {
            color: "rgba(255,255,255,0.2)",
            fontSize: 10,
          },
          min: hasData ? (minPrice > 0 ? minPrice * 0.8 : -0.5) : -0.5,
          max: hasData ? (maxPrice < 5 ? maxPrice + 1 : maxPrice * 1.15) : 5,
        },
        series: [
          {
            name: this.$t("info.price"),
            type: "line",
            smooth: true,
            data: prices.length ? prices : [0],
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              color: "#00b4ff",
              width: 2.5,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0, 180, 255, 0.4)" },
                { offset: 0.5, color: "rgba(0, 100, 255, 0.12)" },
                { offset: 1, color: "rgba(0, 180, 255, 0.02)" },
              ]),
            },
            itemStyle: {
              color: "#00b4ff",
              borderColor: "#0a0e1a",
              borderWidth: 1.5,
            },
            markPoint: {
              data: hasData
                ? [
                    {
                      type: "max",
                      name: this.$t("info.maxValue"),
                      symbol: "circle",
                      symbolSize: 10,
                      label: {
                        formatter: (params) => "$" + params.value,
                        color: "#fff",
                        fontSize: 10,
                        fontWeight: 600,
                        position: "top",
                      },
                      itemStyle: {
                        color: "#7c3aed",
                        borderColor: "#0a0e1a",
                        borderWidth: 2,
                      },
                    },
                  ]
                : [],
            },
          },
        ],
      };

      this.chartInstance.setOption(option, true);
      this.chartInstance.resize();
    },

    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.chartInstance) {
          this.chartInstance.resize();
        }
      }, 100);
    },

    destroyChart() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }
      if (this.chartInstance) {
        this.chartInstance.dispose();
        this.chartInstance = null;
      }
    },
  },
};
</script>

<style scoped>
/* ===== 页面容器 ===== */
.compute-page {
  /* min-height: 100vh; */
  min-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #0a0e1a;
  padding: 40px 20px;
}

/* ===== 背景装饰 ===== */
.page-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}
.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.2;
}
.orb-1 {
  width: 500px;
  height: 500px;
  background: #0066ff;
  top: -200px;
  right: -100px;
}
.orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -150px;
  left: -100px;
}
.orb-3 {
  width: 300px;
  height: 300px;
  background: #00b4ff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.06;
}

.page-container {
  max-width: 1280px;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* ===== 空状态：暂无算力服务器 ===== */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  text-align: center;
  min-height: 400px;
}

.empty-icon {
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 180, 255, 0.06);
  border: 1px solid rgba(0, 180, 255, 0.12);
  color: rgba(0, 180, 255, 0.4);
  margin-bottom: 24px;
  animation: empty-float 3s ease-in-out infinite;
}

.empty-title {
  font-size: 22px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 12px 0;
  letter-spacing: 1px;
}

.empty-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.35);
  margin: 0;
  line-height: 1.6;
}

@keyframes empty-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* ===== 顶部Tab栏 ===== */

.tab-wrap {
  display: flex;
  justify-content: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(10px);
  width: fit-content;
  margin: 0 auto 30px;
  padding: 6px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  /* flex-wrap: wrap; */
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  font-size: 14px;
}
.tab-item:hover {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.04);
}
.tab-item.active {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}
.tab-item.active:hover {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
}

.tab-active-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  animation: pulse-dot 2s ease-in-out infinite;
}

.flag {
  display: flex;
  align-items: center;
}
.gqd {
  width: 22px;
  height: 15px;
  border-radius: 2px;
  object-fit: cover;
}

@keyframes pulse-dot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

/* ===== 主卡片 ===== */
.content-card {
  display: flex;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 36px 10px 10px 30px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  gap: 0px;
  align-items: stretch;
  transition: all 0.3s ease;
  min-height: 340px;
}
.content-card:hover {
  border-color: rgba(0, 180, 255, 0.15);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.card-left {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 14px;
  border-radius: 20px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.1);
  font-size: 12px;
  font-weight: 500;
  color: #00b4ff;
  width: fit-content;
  margin-bottom: 14px;
}
.product-badge .badge-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #00b4ff;
  animation: pulse-dot 2s ease-in-out infinite;
}

.product-name {
  font-size: 36px;
  font-weight: 800;
  margin: 0 0 6px 0;
  color: #fff;
  letter-spacing: 1px;
}

.divider {
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, #00b4ff, #7c3aed);
  border-radius: 4px;
  margin-bottom: 14px;
}

.product-title {
  font-size: 17px;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: rgba(255, 255, 255, 0.75);
}

/* ===== 产品服务介绍文案 ===== */
.service-intro {
  position: relative;
  margin-bottom: 16px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.service-intro-content {
  font-size: 13px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.5);
  max-height: 120px;
  overflow: hidden;
  position: relative;
}

.service-intro-content::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  /* background: linear-gradient(
    to bottom,
    transparent,
    rgba(10, 14, 26, 0.9)
  ); */
  pointer-events: none;
}

.service-intro-content >>> p {
  margin: 0 0 8px 0;
  padding: 0;
}
.service-intro-content >>> p:last-child {
  margin-bottom: 0;
}
.service-intro-content >>> strong {
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
}

/* 展开状态：取消高度限制和渐变遮罩 */
.service-intro-content.expanded {
  max-height: none;
}
.service-intro-content.expanded::after {
  display: none;
}

/* 展开/收起按钮 */
.intro-expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  padding: 4px 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.intro-expand-btn:hover {
  background: rgba(0, 180, 255, 0.08);
  border-color: rgba(0, 180, 255, 0.2);
  color: #00b4ff;
}

.intro-expand-icon {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}
.intro-expand-icon.rotated {
  transform: rotate(180deg);
}

/* ===== 产品服务详情菜单（借鉴顶部国家切换Tab样式） ===== */

.detail-menu {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(10px);
  width: fit-content;
  padding: 6px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  flex-wrap: wrap;
}

.detail-menu-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border-radius: 999px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
}

.detail-menu-btn:hover {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.04);
}

.detail-menu-btn.active {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

.detail-menu-btn.active:hover {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
}

.detail-menu-active-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  animation: pulse-dot 2s ease-in-out infinite;
}

.detail-menu-btn svg {
  flex-shrink: 0;
}

/* ===== 产品描述 ===== */

.product-desc-wrapper {
  position: relative;
  margin-bottom: 20px;
  flex: 1;
}

.product-desc {
  font-size: 14px;
  line-height: normal;
  color: rgba(255, 255, 255, 0.55);
  max-height: 300px;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}
.product-desc.expanded {
  max-height: none;
}

.product-desc >>> p {
  margin: 0 0 10px 0;
  padding: 0;
}
.product-desc >>> p:last-child {
  margin-bottom: 0;
}
.product-desc >>> ul {
  padding-left: 20px;
  margin: 8px 0;
}
.product-desc >>> li {
  margin-bottom: 6px;
}
.product-desc >>> strong {
  color: rgba(255, 255, 255, 0.75);
}

/* ===== 展开/收起按钮 ===== */
.expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  position: relative;
  z-index: 2;
}

.expand-bg {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.expand-btn:hover {
  background: rgba(0, 180, 255, 0.08);
  border-color: rgba(0, 180, 255, 0.2);
  color: #00b4ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(0, 180, 255, 0.05);
}
.expand-btn:active {
  transform: scale(0.97);
}

.expand-text {
  font-size: 13px;
  letter-spacing: 0.3px;
}

.expand-icon {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}
.expand-icon.rotated {
  transform: rotate(180deg);
}

/* ===== 产品数据指标（参考 Detail.vue 统计摘要样式） ===== */
.product-metrics {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.03);
  margin-bottom: 20px;
  width: 84%;
  margin-left: 15px;
}

.metric-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}
.metric-value {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  font-family: "SF Mono", "Courier New", monospace;
}
.metric-value.stat-high {
  color: #ff5722;
}
.metric-value.stat-avg {
  color: #ffd866;
}
.metric-value.increase-up {
  color: #00c951;
}
.metric-value.increase-down {
  color: #ff6b6b;
}
.metric-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.metric-divider {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.04);
}

.card-right {
  flex: 0.7;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  gap: 10px;
}
.chart-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
}
.chart-unit {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.2);
  font-family: "SF Mono", "Courier New", monospace;
  white-space: nowrap;
}

/* ===== 趋势图时间范围切换 ===== */
.chart-range-tabs {
  display: flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 3px;
}
.chart-range-btn {
  padding: 4px 14px;
  border-radius: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.35);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
  white-space: nowrap;
}
.chart-range-btn:hover {
  color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.04);
}
.chart-range-btn.active {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  color: #fff;
  box-shadow: 0 2px 10px rgba(0, 100, 255, 0.25);
}

.chart-box {
  width: 100%;
  height: 260px;
  flex: 1;
  min-height: 200px;
}

/* ===== 立即购买按钮（滚动吸底） ===== */
.btn-wrap {
  position: sticky;
  bottom: 0;
  width: 100%;
  margin-top: 20px;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom));
  display: flex;
  justify-content: center;
  background: rgba(10, 14, 26, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.3);
}

.join-btn {
  position: relative;
  padding: 0 56px;
  height: 56px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  border-radius: 16px;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  font-family: inherit;
  box-shadow: 0 4px 30px rgba(0, 100, 255, 0.25);
}
.join-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 50px rgba(0, 100, 255, 0.35);
}
.join-btn:active {
  transform: translateY(-1px);
}

.btn-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}
.join-btn:hover .btn-glow {
  opacity: 1;
}

.btn-arrow {
  display: inline-block;
  transition: transform 0.35s ease;
  font-size: 20px;
}
.join-btn:hover .btn-arrow {
  transform: translateX(6px);
}

/* ===== 购买弹窗 ===== */
.purchase-modal-content {
  padding: 4px 0;
}

.product-info-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(0, 180, 255, 0.06);
  border-radius: 12px;
  border: 1px solid rgba(0, 180, 255, 0.08);
  margin-bottom: 20px;
}
.product-flag {
  width: 32px;
  height: 22px;
  border-radius: 4px;
  object-fit: cover;
}
.product-name-text {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}
.product-price-tag {
  font-size: 18px;
  font-weight: 800;
  color: #00b4ff;
  font-family: "SF Mono", "Courier New", monospace;
}

.modal-section {
  margin-bottom: 18px;
}
.modal-section:last-of-type {
  margin-bottom: 0;
}

.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 10px;
}
.label-icon {
  font-size: 16px;
}

/* ===== 周期选择 ===== */
.period-group-modal {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.period-btn-modal {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
  border: 1.5px solid rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.5);
  position: relative;
  overflow: hidden;
  min-width: 0;
}
.period-btn-modal::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #f44336, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.period-btn-modal:hover {
  background: rgb(244 67 54 / 7%);
  border-color: rgb(244 67 54 / 24%);
  color: #f44336;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.1);
}
.period-btn-modal:hover::before {
  opacity: 1;
}
.period-btn-modal.active {
  background: linear-gradient(
    135deg,
    rgba(0, 180, 255, 0.15),
    rgba(0, 100, 255, 0.08)
  );
  border-color: #00b4ff;
  color: #00b4ff;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 100, 255, 0.2);
}
.period-btn-modal.active::before {
  background: linear-gradient(90deg, transparent, #00b4ff, transparent);
  opacity: 1;
}

.period-days-wrap {
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.period-days-modal {
  font-size: 16px;
  font-weight: 800;
}
.period-unit-modal {
  font-size: 11px;
  font-weight: 500;
}
.period-btn-modal.active .period-unit-modal {
  color: rgba(0, 180, 255, 0.5);
}

/* ===== 额外收益率徽章（更突出） ===== */
.period-rate-badge {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 800;
  padding: 2px 8px 2px 6px;
  border-radius: 20px;
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.15),
    rgba(244, 67, 54, 0.08)
  );
  color: #f44336;
  transition: all 0.3s ease;
  border: 1px solid rgba(244, 67, 54, 0.15);
}
.period-rate-badge .rate-icon-modal {
  flex-shrink: 0;
  stroke: #f44336;
}
.rate-value-modal {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.period-btn-modal:hover .period-rate-badge {
  background: linear-gradient(
    135deg,
    rgba(244, 67, 54, 0.25),
    rgba(244, 67, 54, 0.12)
  );
  border-color: rgba(244, 67, 54, 0.3);
  transform: scale(1.08);
  box-shadow: 0 4px 16px rgba(244, 67, 54, 0.2);
}
.period-btn-modal.active .period-rate-badge {
  background: linear-gradient(
    135deg,
    rgba(0, 180, 255, 0.25),
    rgba(0, 100, 255, 0.12)
  );
  border-color: rgba(0, 180, 255, 0.3);
  color: #00b4ff;
  box-shadow: 0 4px 16px rgba(0, 100, 255, 0.2);
}
.period-btn-modal.active .period-rate-badge .rate-icon-modal {
  stroke: #00b4ff;
}
.period-btn-modal.active .rate-value-modal {
  color: #00b4ff;
}

/* ===== 截止时间 ===== */
.deadline-section {
  margin-bottom: 18px;
}

.deadline-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 10px;
  background: rgba(255, 215, 0, 0.04);
  border: 1.5px solid rgba(255, 215, 0, 0.08);
  transition: all 0.3s ease;
  width: fit-content;
}
.deadline-modal:hover {
  border-color: rgba(255, 215, 0, 0.15);
  background: rgba(255, 215, 0, 0.06);
}
.deadline-time-modal {
  font-size: 16px;
  font-weight: 700;
  color: #ffd700;
  font-family: "SF Mono", "Courier New", monospace;
  letter-spacing: 0.5px;
}

/* ===== 数量控制 ===== */
.quantity-control-modal {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  overflow: hidden;
  border: 1.5px solid rgba(255, 255, 255, 0.06);
  width: fit-content;
}
.quantity-control-modal:hover {
  border-color: rgba(255, 255, 255, 0.12);
}
.quantity-control-modal:focus-within {
  border-color: rgba(0, 180, 255, 0.3);
  box-shadow: 0 0 0 3px rgba(0, 180, 255, 0.05);
}

.qty-btn-modal {
  width: 38px;
  height: 38px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qty-btn-modal:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}
.qty-btn-modal:active {
  transform: scale(0.92);
}

.qty-input-modal {
  width: 56px;
  height: 38px;
  background: transparent;
  border: none;
  border-left: 1.5px solid rgba(255, 255, 255, 0.06);
  border-right: 1.5px solid rgba(255, 255, 255, 0.06);
  color: #fff;
  text-align: center;
  font-size: 17px;
  font-weight: 700;
  outline: none;
  -moz-appearance: textfield;
  font-family: "SF Mono", "Courier New", monospace;
}
.qty-input-modal::-webkit-outer-spin-button,
.qty-input-modal::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* ===== 收益预览 ===== */
.profit-preview {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.profit-grid {
  display: flex;
  align-items: center;
  gap: 16px;
}

.profit-item-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.profit-label-modal {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
}
.profit-value-modal {
  font-size: 18px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.8);
  font-family: "SF Mono", "Courier New", monospace;
  margin-top: 2px;
}
.profit-value-modal.period-profit-modal {
  color: #a78bfa;
}
.profit-value-modal.total-profit-modal {
  color: #34d399;
}
.profit-divider-modal {
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, 0.06);
}

/* ===== 周期收益百分比高亮 ===== */
.period-profit-item {
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(167, 139, 250, 0.08),
    rgba(124, 58, 237, 0.04)
  );
  border-radius: 10px;
  padding: 8px 12px;
  border: 1px solid rgba(167, 139, 250, 0.12);
}
.period-rate-highlight {
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 800;
  color: #a78bfa;
  background: linear-gradient(
    135deg,
    rgba(167, 139, 250, 0.2),
    rgba(124, 58, 237, 0.1)
  );
  border: 1px solid rgba(167, 139, 250, 0.25);
  letter-spacing: 0.5px;
  box-shadow: 0 2px 12px rgba(124, 58, 237, 0.15);
}

/* ===== 总计 ===== */
.total-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(255, 215, 0, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(255, 215, 0, 0.06);
}
.total-label-modal {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.4);
}
.total-price-modal {
  font-size: 24px;
  font-weight: 900;
  color: #ffd700;
  font-family: "SF Mono", "Courier New", monospace;
}

/* ===== 购买弹窗样式覆盖 ===== */
.purchase-dialog >>> .el-dialog {
  background: #1a1e2e;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  margin-top: 5vh !important;
}
.purchase-dialog >>> .el-dialog__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px 24px;
}
.purchase-dialog >>> .el-dialog__title {
  color: #fff;
  font-size: 17px;
  font-weight: 700;
}
.purchase-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.4);
}
.purchase-dialog >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}
.purchase-dialog >>> .el-dialog__body {
  padding: 20px 24px;
}
.purchase-dialog >>> .el-dialog__footer {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 14px 24px;
}
.purchase-dialog >>> .el-button--default {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}
.purchase-dialog >>> .el-button--default:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}
.purchase-dialog >>> .el-button--primary {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
}
.purchase-dialog >>> .el-button--primary:hover {
  opacity: 0.85;
}
.purchase-dialog >>> .el-button--primary.is-disabled {
  background: rgba(0, 100, 255, 0.4);
  border: none;
}

/* ===== 响应式 ===== */
@media (max-width: 1024px) {
  .content-card {
    flex-direction: column;
    padding: 28px;
  }
  .card-right {
    flex: 1;
  }
  .chart-box {
    height: 200px;
  }
}

@media (max-width: 768px) {
  .compute-page {
    padding: 16px 10px;
  }
  .tab-wrap {
    border-radius: 14px;
    padding: 4px;
    width: 100%;
    justify-content: center;
  }
  .tab-item {
    padding: 6px 14px;
    font-size: 12px;
    gap: 6px;
  }
  .tab-item .country-name {
    font-size: 12px;
  }
  .gqd {
    width: 18px;
    height: 12px;
  }
  .detail-menu {
    width: 100%;
    border-radius: 14px;
    padding: 4px;
    justify-content: center;
  }
  .detail-menu-btn {
    padding: 6px 14px;
    font-size: 12px;
    gap: 6px;
  }
  .content-card {
    padding: 18px;
    border-radius: 14px;
  }

  .product-name {
    font-size: 24px;
  }
  .product-title {
    font-size: 15px;
  }
  .product-desc {
    font-size: 13px;
  }
  .product-metrics {
    flex-wrap: wrap;
    gap: 10px;
  }
  .metric-divider {
    display: none;
  }
  .metric-value {
    font-size: 17px;
  }
  .chart-box {
    height: 160px;
  }
  .join-btn {
    padding: 0 32px;
    height: 48px;
    font-size: 15px;
    width: 100%;
    justify-content: center;
    border-radius: 12px;
  }
  .purchase-dialog >>> .el-dialog {
    width: 95% !important;
  }
  .period-btn-modal {
    padding: 6px 12px;
    font-size: 13px;
  }
  .period-days-modal {
    font-size: 14px;
  }
  .deadline-modal {
    width: 100%;
    justify-content: center;
  }
  .deadline-time-modal {
    font-size: 14px;
  }
  .profit-grid {
    flex-wrap: wrap;
    gap: 8px;
  }
  .profit-divider-modal {
    display: none;
  }
  .profit-item-modal {
    flex: 1;
    min-width: 60px;
  }
  .total-price-modal {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .tab-item {
    padding: 4px 10px;
    font-size: 11px;
    min-width: 50px;
  }
  .tab-item .country-name {
    font-size: 10px;
  }
  .gqd {
    width: 15px;
    height: 10px;
  }
  .product-name {
    font-size: 20px;
  }
  .product-metrics {
    padding: 10px 12px;
  }
  .metric-value {
    font-size: 17px;
  }
  .chart-box {
    height: 140px;
    min-height: 120px;
  }
  .period-btn-modal {
    padding: 5px 10px;
    font-size: 12px;
  }
  .period-days-modal {
    font-size: 13px;
  }
  .qty-btn-modal {
    width: 34px;
    height: 34px;
  }
  .qty-input-modal {
    width: 48px;
    height: 34px;
    font-size: 15px;
  }
  .deadline-time-modal {
    font-size: 13px;
  }
  .profit-value-modal {
    font-size: 15px;
  }
  .total-price-modal {
    font-size: 18px;
  }
}

/* ===== 金额汇总区域 ===== */
.summary-section {
  margin-top: 20px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.3s ease;
}
.summary-section:hover {
  border-color: rgba(0, 180, 255, 0.12);
  background: rgba(255, 255, 255, 0.03);
}

.summary-grid {
  display: flex;
  align-items: stretch;
  gap: 0;
}

.summary-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 12px;
  position: relative;
  transition: all 0.3s ease;
}
.summary-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 20%;
  height: 60%;
  width: 1px;
  background: rgba(255, 255, 255, 0.06);
}

.summary-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.35);
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}
.summary-label .label-icon {
  font-size: 14px;
}

.summary-value {
  font-size: 22px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.75);
  font-family: "SF Mono", "Courier New", monospace;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* 手续费特殊样式 */
.summary-item:not(.total-item):hover .summary-value {
  color: rgba(255, 255, 255, 0.9);
}

.fee-value {
  color: rgba(255, 165, 0, 0.6);
  font-size: 20px;
}

/* 可用余额特殊样式 */
.balance-item {
  flex: none;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 10px 14px;
  background: rgba(0, 180, 255, 0.06);
  border: 1px dashed rgba(0, 180, 255, 0.25);
  border-radius: 8px;
}

.balance-item .summary-label {
  margin-bottom: 0;
}

.balance-value {
  color: #4fc3ff;
  font-size: 20px;
}

/* 总计高亮 */
.total-item {
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.06),
    rgba(255, 165, 0, 0.03)
  );
  border-radius: 10px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 215, 0, 0.08);
}
.total-item::after {
  display: none !important;
}

.total-value {
  font-size: 26px;
  background: linear-gradient(135deg, #ffd700, #ff8c00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 900;
  letter-spacing: 0.5px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .summary-section {
    padding: 12px 14px;
  }
  .summary-grid {
    flex-direction: column;
    gap: 6px;
  }
  .summary-item:not(:last-child)::after {
    display: none;
  }
  .summary-item {
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 8px;
  }
  .summary-item .summary-label {
    margin-bottom: 0;
    font-size: 13px;
  }
  .summary-value {
    font-size: 18px;
  }
  .fee-value {
    font-size: 16px;
  }
  .total-value {
    font-size: 20px;
  }
  .total-item {
    padding: 8px 12px;
    margin-top: 4px;
  }
}

@media (max-width: 480px) {
  .summary-section {
    padding: 10px 10px;
  }
  .summary-item {
    padding: 4px 6px;
  }
  .summary-label {
    font-size: 12px;
  }
  .summary-value {
    font-size: 16px;
  }
  .total-value {
    font-size: 18px;
  }
}
.xxb {
  color: #ffc107;
  font-size: 15px;
  cursor: pointer;
}
.xxb:hover {
  color: rgba(255, 255, 255, 0.6);
}
.country-name {
  white-space: nowrap;
}
</style>
